import React, { createContext } from 'react'

export const SectionThemeContext = createContext()

export default SectionThemeContext
